import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Periods = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 8px;
    margin-top: 16px;
`;

export const CustomFields = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 12px 16px;
    margin-top: 16px;
`;

// Детализация стоит под вкладками: она относится к обоим способам задать период.
export const Detailing = styled.div`
    display: grid;
    grid-template-columns: 100px 1fr;
    gap: 12px;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid ${colors.divider};
`;
